//@flow
import React from 'react';
import OfficeShell from '../../Shell/components/OfficeShell.react';
import formUtils from '../../Utils/form';
import CustomerApiInterface from '../../APIInterfaces/customer';
import browserHistory from '../../../utils/history';

type Props = {};
type State = {
  isSubmitting:boolean,
};

const emailPattern = formUtils.getWorkEmailPattern();

const config = {
  title: 'Sharing is Caring.',
  subtitle: 'Earn up to $250.',
  tableTitle: 'NatureBox SnackPass Referral',
  description: `
  Know someone who needs a great gift idea? Refer your office admin, HR representative, wellness leader, clients, or anyone looking to send customizable snack boxes. If they sign up, we’ll send you up to $250 of NatureBox credit to say thanks! It really does pay to know people!
  <br />
  <br />
  Spread the word and start collecting free snacks.
  `,
  terms: `
  Current offices excluded. Minimum purchase of (10) snack boxes to qualify for up to a $200 NatureBox credit. (10-25) snack boxes = $25 credit. (26-50) snack boxes = $50 credit. (51-100) snack boxes = $100 credit. (100+) snack boxes = $200 credit.
  `,
};

const {title, subtitle, description, tableTitle} = config;

const groups = [
  [
    {
      label: 'Your Referral Purchases...',
      className: 'row-item row-label',
    },
    {
      value: '10-25',
      label: 'SnackPasses',
      className: 'row-item row-value first-row',
    },
    {
      value: '26-50',
      label: 'SnackPasses',
      className: 'row-item row-value first-row',
    },
    {
      value: '51-100',
      label: 'SnackPasses',
      className: 'row-item row-value first-row',
    },
    {
      value: '100+',
      label: 'SnackPasses',
      className: 'row-item row-value first-row',
    },
  ],
  [
    {
      label: 'You Get...',
      className: 'row-item row-label',
    },
    {
      value: '$25',
      label: 'NatureBox Credit',
      className: 'row-item row-value second-row',
    },
    {
      value: '$50',
      label: 'NatureBox Credit',
      className: 'row-item row-value second-row',
    },
    {
      value: '$100',
      label: 'NatureBox Credit',
      className: 'row-item row-value second-row',
    },
    {
      value: '$250',
      label: 'NatureBox Credit',
      className: 'row-item row-value second-row',
    },
  ],
];

function _setCustomInvalidMessage(event) {
  const errorMessage = "Work email required. Questions? Contact sales@naturebox.com";
  event.target.setCustomValidity(errorMessage);
}
function _resetCustomValidity(event) {
  event.target.setCustomValidity('');
}

const FORM_FIELDS = [
  "name",
  "referral_company_name",
  "email",
  "phone",
  "referrer_name",
  "referrer_email",
];

export default class OfficeReferApp extends React.PureComponent<Props, State> {
  state = {
    isSubmitting: false,
  }

  handleSubmit = (event:any) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({isSubmitting: true});

    const values = {};

    FORM_FIELDS.forEach(key => values[key] = event.target.elements[key].value);

    const successUrl = '/office/refer/thanks';

    return CustomerApiInterface.submitOfficeReferForm(values)
      .then(() => {
        this.setState({isSubmitting: false});
        return browserHistory.push(successUrl);
      })
      .catch(() => {
        this.setState({isSubmitting: false});
        const msg = `We were unable to complete the request. Please refresh the page and try again. If problem persists, please contact support@naturebox.com.`;
        window.alert(msg);
      });
  }

  renderForm() {
    return (
      <div className="office-refer-form">
        <form
          className="formsy-form"
          onSubmit={this.handleSubmit}
        >
          <div className="row form-subtitle">
            Referral Info
          </div>
          <div className="row">
            <input id="name" maxLength="80" name="name" size="20" type="text" placeholder="Referral name" required={true}/>
          </div>
          <div className="row">
            <input id="referral_company_name" maxLength="100" name="referral_company_name" size="20" type="text" placeholder="Referral company name" required={true}/>
          </div>
          <div className="row">
            <input id="email" maxLength="80" name="email" size="20" type="text" placeholder="Referral email address" required={true} onInput={_resetCustomValidity} onInvalid={_setCustomInvalidMessage} pattern={emailPattern}/>
          </div>
          <div className="row">
            <input id="phone" maxLength="80" name="phone" size="20" type="text" placeholder="Referral phone number" required={true}/>
          </div>
          <div className="row form-subtitle">
            Your Info
          </div>
          <div className="row">
            <input id="referrer_name" maxLength="80" name="referrer_name" size="20" type="text" placeholder="Your name" required={true}/>
          </div>
          <div className="row">
            <input id="referrer_email" maxLength="80" name="referrer_email" size="20" type="text" placeholder="Your email address" required={true}/>
          </div>
          <div className="row">
            <input type="submit" name="submit" value="Submit referral" id="ss-submit" disabled={this.state.isSubmitting} />
          </div>
        </form>
      </div>
    );
  }

  renderLarge() {
    return (
      <div className="office-refer-lg">
        <section className="office-refer-lg-left">
          <div className="office-refer-header">
            <h1>
              <span>{title}</span>
              <span>{subtitle}</span>
            </h1>
          </div>
          <div className="office-refer-form-container">
            {this.renderForm()}
          </div>
        </section>
        <section>
          <p
            className="office-refer-copy"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: description}}
          >
          </p>
          <div className="office-refer-table-container">
            <h3 className="office-refer-table-header">{tableTitle}</h3>
            <div className="office-refer-table">
              {groups.map((group, index) => (
                <div
                  key={index}
                  className="office-refer-table-row"
                >
                  {group.map((item, i) => (
                    <div
                      key={i}
                      className={item.className}
                    >
                      <div className="row-item-inner">
                        {item.value && <h3 className="row-item-value">{item.value}</h3>}
                        {item.label && <p className="row-item-label">{item.label}</p>}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }

  renderSmall() {
    return (
      <div className="office-refer-sm">
        <div className="office-refer-header">
          <h1>
            <span>{title}</span>
            <span>{subtitle}</span>
          </h1>
          <p
            className="office-refer-copy"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: description}}
          >
          </p>
        </div>
        <div className="office-refer-table-container">
          <h3 className="office-refer-table-header">{tableTitle}</h3>
          <div className="office-refer-table">
            {groups.map((group, index) => (
              <div
                key={index}
                className="office-refer-table-row"
              >
                {group.map((item, i) => (
                  <div
                    key={i}
                    className={item.className}
                  >
                    <div className="row-item-inner">
                      {item.value && <h3 className="row-item-value">{item.value}</h3>}
                      {item.label && <p className="row-item-label">{item.label}</p>}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="office-refer-form-container">
          {this.renderForm()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <OfficeShell pageTitle="Office Referral | NatureBox">
        <div className="office-refer">
          {/* NOTE: conditional rendering based on screen
          size is performed in associated scss file */}
          {this.renderLarge()}
          {this.renderSmall()}
        </div>
      </OfficeShell>
    );
  }
}
